import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { dateAndTimeConverter, openInNewTab } from "../../Utils/constants";
import { InfoIcon, LocationIcon } from "../../Assets/assets";
import ConditionalRender from "../../Components/ConditionalRender/ConditionalRender";
import Header from "../../Components/Header/Header";

function SelectedVolunteering(props) {
  const { volunteeringId } = useParams("volunteeringId");
  const [volunteeringData, setVolunteeringData] = useState(null);

  useEffect(() => {
    if (props.volunteer.data[volunteeringId]) {
      setVolunteeringData(props.volunteer.data?.[volunteeringId]);
    } else {
      setVolunteeringData(null);
    }
  }, [props.volunteer.data, volunteeringId]);

  return (
    <>
      <Header
        languageData={props.languageData}
        title={props.languageData.viewVolunteering}
        backOnClick={() => {
          props.navigate("/");
        }}
      />
      <div className="remaining-body-height background-white-half flex-justify-content-center padding-large font-family-RHD-medium overflow-scroll">
        <div className=" max-width-500px inherit-parent-width">
          <TitleCard
            data={volunteeringData}
            language={props.profile.language}
            status={volunteeringData?.status.currentStatus}
          />

          <ConditionalRender
            condition={volunteeringData?.status.currentStatus === "OPEN"}
          >
            <div className=" margin-top-large background-color-grey padding-medium">
              <div>
                {props.languageData?.coordinator}:{" "}
                {volunteeringData?.contact.name[props.profile.language]}
              </div>
              <div>
                {" "}
                {props.languageData?.phone}:{" "}
                {volunteeringData?.contact.phoneNumber}{" "}
              </div>
              {volunteeringData?.contact.email && (
                <div>
                  {props.languageData?.email}:{" "}
                  <span
                    onClick={() => {
                      window.open(`mailto:${volunteeringData.contact.email}`);
                    }}
                    className="font-color-primary"
                  >
                    {volunteeringData.contact.email}
                  </span>
                </div>
              )}
              {volunteeringData?.contact.link && (
                <div>
                  {props.languageData?.link}:{" "}
                  <span
                    onClick={() => {
                      openInNewTab(`https://${volunteeringData.contact.link}`);
                    }}
                    className=" font-color-primary"
                  >
                    {volunteeringData.contact.link}
                  </span>
                </div>
              )}
              <div className=" padding-top-larger font-size-medium">
                {props.languageData?.contactCoordinator}
              </div>
            </div>
          </ConditionalRender>

          <ConditionalRender
            condition={volunteeringData?.status.currentStatus === "CLOSED"}
          >
            <div className=" margin-top-large background-color-FFF4EA font-color-CB6F19 padding-medium display-flex flex-align-items-center">
              {" "}
              <InfoIcon color="#CB6F19" />{" "}
              <span className=" padding-left-default">
                {props.languageData.noAcceptingVolunteers}
              </span>{" "}
            </div>
          </ConditionalRender>

          <div
            className={`${
              volunteeringData?.status.currentStatus === "CLOSED"
                ? "font-color-quaternary"
                : ""
            } margin-top-large background-color-grey padding-medium`}
          >
            <ConditionalRender condition={volunteeringData?.description}>
              <div>{props.languageData.description}:</div>
              <div>{volunteeringData?.description[props.profile.language]}</div>
            </ConditionalRender>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    profile: state.profile,
    volunteer: state.volunteer,
  };
};

const mapDispatchToProps = function () {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectedVolunteering);

const TitleCard = (props) => {
  return (
    <div
      onClick={() => {
        props.cardClick(props.data?.documentId);
      }}
      data-cy={`${props.data?.documentId}-volunteering-title-card`}
      className="inherit-parent-width display-flex margin-bottom-large background-color-grey"
      style={{
        minHeight: "100px",
      }}
    >
      <div className="height-width-100px">
        {props.data?.thumbnailSrc?.url ? (
          <img
            className="height-width-100px"
            style={{
              borderRadius: "4px 0px 0px 4px",
              //   paddingLeft: "2px",
              //   paddingTop: "2px",
              objectFit: "fill",
            }}
            src={props.data?.thumbnailSrc?.url || ""}
            alt="volunteering-thumbnail"
          />
        ) : (
          <div
            className="shimmer inherit-parent-width inherit-parent-height"
            style={{
              borderRadius: "2px",
              //   paddingLeft: "2px",
              objectFit: "fill",
            }}
          />
        )}
      </div>
      <div
        className=" display-flex padding-medium"
        style={{ width: "calc(100% - 100px)" }}
      >
        <div className="">
          <div className=" display-flex flex-align-items-center font-color-quaternary">
            <div className=" font-size-small ">
              {props.data?.contact.name[props.language]}
            </div>
            <div className=" dot-4px-quaternary margin-horizontal-default" />
            <div className=" font-size-small  ">
              {dateAndTimeConverter(props.data?.createdAt, "secondDate")}
            </div>
          </div>

          <div
            className={`${
              props.status === "CLOSED" ? "font-color-quaternary" : ""
            }  font-family-RHD-medium padding-top-default`}
          >
            {props.data?.title[props.language]}
          </div>

          <div className=" font-family-RHD-medium font-size-medium flex-align-item-center padding-top-default  font-color-quaternary">
            <LocationIcon color={"#868686"} />{" "}
            {props.data?.location.address[props.language]},{" "}
            {props.data?.location.city[props.language]}
          </div>
        </div>

        {/* <ArrowIcon /> */}
      </div>
    </div>
  );
};
